module.exports = __webpack_public_path__ + "statics/media/aspire-logo_white_no-claim.1792200c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/aspire-logo/aspire-logo_white_no-claim.svg
// module id = 1216
// module chunks = 138